import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Icon from 'ol/style/Icon'

import {
  colors,
  createMiniMapUnSelectedFeatureStyle,
  createMiniMapSelectedFeatureStyle,
} from '../../../ol-styles'
import RegularShape from 'ol/style/RegularShape'

export function createOverviewStyle(selected, selectedGcpId) {
  const includedStyle = selected
    ? createMiniMapSelectedFeatureStyle({
        color: colors.orangeDot,
        strokeColor: colors.orangeDot,
      })
    : createMiniMapUnSelectedFeatureStyle({
        color: colors.greenDot,
        strokeColor: colors.orangeDot,
      })
  const excludedStyle = selected
    ? createMiniMapSelectedFeatureStyle({
        color: colors.grayDot,
        strokeColor: colors.orangeDot,
      })
    : createMiniMapUnSelectedFeatureStyle({
        color: colors.grayDot,
      })

  const gcpStyle = new Style({
    image: new Icon({
      src:
        "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 700 700'%3e%3cpath fill='%23fff' d='M92 20h510v510H92z'/%3e%3cpath d='M590.05 16.004h-480c-13.32 0-24 10.801-24 24v480c0 13.199 10.68 24 24 24h480c13.199 0 24-10.801 24-24v-480c0-13.199-10.797-24-24-24zm-240 264v246h-240c-3.36 0-6-2.64-6-6v-240h246v-246h240c3.242 0 6 2.64 6 6v240z'/%3e%3c/svg%3e",
      opacity: selected ? 1 : 0.5,
    }),
  })

  return olFeature => {
    return olFeature.get('type') === 'gcp'
      ? gcpStyle
      : olFeature.get('include')[selectedGcpId]
      ? includedStyle
      : excludedStyle
  }
}

const stroke = new Stroke({ color: colors.blue, width: 3 })
const fill = new Fill({ color: [0, 0, 0, 0] })
export const markerStyle = new Style({
  image: new RegularShape({
    fill,
    stroke,
    points: 4,
    radius: 20,
    radius2: 0,
    angle: Math.PI / 4,
  }),
})
